import { ProviderActivationStatus } from '@uplift/api';
import { useCurrentuser } from '@uplift/contexts';
import { useProviderActivationQuery } from '@uplift/queries';

export const useGoLiveLocked = (providerGoLiveAllowed = false) => {
  const me = useCurrentuser();
  const { data: activation, isLoading } = useProviderActivationQuery(me?.id);

  const accountLocked = isLoading || !activation || activation.status === ProviderActivationStatus.live;
  const locked = accountLocked && !providerGoLiveAllowed;

  return { locked, isLoading };
};
